import config from 'config/appConfig';
import { DivConst } from 'constants/divConst';
import { isEmpty, isNotEmpty, formatTimeToDate } from 'utils/app';

/**
 * フォームのプレビューURLを取得します。
 */
export function getPreviewUrl(formPreviewCd: string): string {
  return `${config.url.userWeb}/form/preview/${formPreviewCd}`;
}

/**
 * フォームのプレビューURLを開きます。
 */
export function openPreviewUrl(formPreviewCd: string): void {
  window.open(getPreviewUrl(formPreviewCd), '_blank');
}

/**
 * フォームの公開URLを取得します。
 */
export function getProductionUrl(formCd: string): string {
  return `${config.url.userWeb}/form/${formCd}`;
}

/**
 * フォームの公開URLを開きます。
 */
export function openProductionUrl(formCd: string): void {
  window.open(getProductionUrl(formCd), '_blank');
}

/**
 * フォームのLINE公開URLを取得します。
 */
export function getLineProductionUrl(formCd: string): string {
  return `${config.url.userWeb}/form/line/${formCd}`;
}

/**
 * フォームのLINE公開URLを開きます。
 */
export function openLineProductionUrl(formCd: string): void {
  window.open(getLineProductionUrl(formCd), '_blank');
}

/**
 * 公開期間の文字列を作成します。。
 * 公開予定日よりも公開日を優先して表示します。
 */
export function formatPublishTerm(props: {
  formStatusDiv: number;
  publishStartAt: number;
  publishEndAt: number;
  publishedAt: number;
  terminatedAt: number;
}): string {
  // eslint-disable-next-line no-useless-assignment -- 後続の条件分岐で上書きされるため初期値としてnullを設定
  let startAt = null;
  // eslint-disable-next-line no-useless-assignment -- 後続の条件分岐で上書きされるため初期値としてnullを設定
  let endAt = null;

  // 予約ステータスの場合は、予約日を優先
  if (props.formStatusDiv == DivConst.items.formStatus.reserved.value) {
    startAt = props.publishStartAt;
    endAt = props.publishEndAt;
  }
  // その他のステータスの場合は、公開実績を優先
  else {
    startAt = isNotEmpty(props.publishedAt) ? props.publishedAt : props.publishStartAt;

    endAt = isNotEmpty(props.terminatedAt) ? props.terminatedAt : props.publishEndAt;
  }

  if (isEmpty(startAt) && isEmpty(endAt)) {
    return '指定なし';
  }
  if (isEmpty(startAt) && isNotEmpty(endAt)) {
    return `${formatTimeToDate(new Date().getTime(), 'yyyy/MM/dd')} 〜 ${formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
  }
  if (isNotEmpty(startAt) && isEmpty(endAt)) {
    return `${formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 無期限`;
  }

  return `${formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 ${formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
}
